<template>
  <div class="ride-add-private-transport-form">
    <div class="notification is-white">
      <!-- <button class="delete is-medium" @click="close"></button> -->
      <div class="subtitle" @click="close">
        <i class="fa fa-chevron-left" style="margin-right: 6px" />Request a Demo
      </div>
      <p style="margin-bottom: 10px">
        <svgicon
          icon="tuk-word"
          width="28"
          height="28"
          color="navy"
          :fill="true"
          style="margin-top: -8px"
        ></svgicon>
        is free for apartments, condominiums and hotels with their own transport
        fleets.
      </p>
      <p class="question" style="margin-bottom: 10px">
        Enter your business details and we'll be in touch.
      </p>

      <!-- Google Location Input-->
      <div class="field">
        <p class="control has-icons-left">
          <input
            class="input is-medium"
            v-model="locationInput"
            ref="autocomplete"
            placeholder="Location"
            onfocus="value = ''"
            type="text"
          />
          <span class="icon is-small is-left">
            <i class="fas fa-globe"></i>
          </span>
        </p>
      </div>

      <div class="field">
        <p class="control has-icons-left">
          <input
            class="input is-medium"
            v-model="businessName"
            type="text"
            placeholder="Business Name"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-building"></i>
          </span>
        </p>
      </div>

      <p class="question">
        How can you be contacted?
        <!-- <span class="has-text-info">(optional)</span> -->
      </p>
      <div class="field">
        <p class="control has-icons-left">
          <input
            class="input is-medium"
            v-model="contact"
            type="text"
            placeholder="Email / Phone"
          />
          <span class="icon is-small is-left">
            <i class="far fa-envelope"></i>
          </span>
        </p>
      </div>

      <p class="question">How big is your fleet?</p>
      <div class="buttons" style="margin-bottom: 0">
        <span
          v-for="f in fleetSizes"
          :key="f"
          class="button"
          :class="{ 'is-info': fleetSize === f }"
          @click="fleetSize = f"
          >{{ f }}</span
        >
      </div>

      <p class="question">What's your relation to the business?</p>
      <div class="buttons" style="margin-bottom: 0">
        <span
          v-for="r in relations"
          :key="r"
          class="button"
          :class="{ 'is-info': relation === r }"
          @click="relation = r"
          >{{ r }}</span
        >
      </div>

      <!-- <div style="margin-top: 20px; margin-bottom: 20px"> -->
      <div style="margin-top: 20px; margin-bottom: 10px">
        <span
          class="button is-primary is-rounded is-fullwidth"
          :disabled="!validForm"
          @click="submit"
        >
          Submit Request &nbsp;<i class="fa fa-chevron-right fa-lg" />
        </span>
      </div>

      <!-- <div class="has-text-right">
        <a
          class="button is-rounded"
          href="https://m.me/tukcommerce"
          target="_blank"
        >
          Or chat with us&nbsp;
          <i class="far fa-comment fa-lg has-text-link" />
        </a>
      </div> -->
    </div>
  </div>
</template>

<script>
import $Scriptjs from "scriptjs";

export default {
  data() {
    return {
      locationInput: "",
      autocomplete: undefined,
      place: undefined, // google place result
      fullAddress: "",
      phoneNumber: "",
      url: "",
      businessName: "", // name of business
      country: "th", // default to thailand
      relations: ["Staff", "Customer"], //, "Friend"],
      fleetSizes: ["0", "1-2", "3-5", "5+"],
      relation: null,
      contact: null,
      fleetSize: null,
    };
  },
  computed: {
    validForm() {
      if (
        this.relation &&
        this.fullAddress &&
        this.businessName &&
        this.contact &&
        this.fleetSize
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    var googlePlacesURL = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss&libraries=places`;
    $Scriptjs(googlePlacesURL, () => this.initGoogle());
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      if (!this.validForm) {
        var msg = "Please fill in the required fields<br>Or chat with us";
        this.warningToast(msg, "top");
        return;
      }
      var data = {
        building_name: this.businessName,
        address: this.fullAddress,
        relation: this.relation,
        contact: this.contact,
        fleet_size: this.fleetSize,
        user: JSON.stringify(this.$store.state.user),
        type: "Private Transport Lead from App",
      };
      this.$store.dispatch("sendEmail", data);
      var successMsg = `Thank you for your recommendation! We'll be in touch within 2 business days 🙏🏽`;
      this.success(successMsg);
      this.close();
    },
    initGoogle() {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        {
          types: [], // uses all, options are ["address", "establishment", "geocode"]
          componentRestrictions: { country: this.country },
        }
      );
      this.geolocate();

      this.autocomplete.addListener("place_changed", () => {
        var place = this.autocomplete.getPlace();
        this.businessName = place.name;
        this.fullAddress = place.formatted_address;
        this.phoneNumber = place.international_phone_number;
        this.url = place.url;
        this.place = place;

        this.locationInput = place.formatted_address; //place.types.join(", ");
        this.console(`The user picked ${name}`, place);
      });
    },
    geolocate() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy,
          });
          this.autocomplete.setBounds(circle.getBounds());
        });
      }
    },
  },
};
</script>

<style scoped>
.notification {
  padding: 12px;
  box-shadow: 0 0 4px #bbb;
  /* height: calc(100vh - 200px); */
  /* padding-bottom: 200px; */
}
p {
  margin-bottom: 10px;
}
.question {
  font-weight: 500;
  padding-top: 6px;
}
</style>